<template>
  <div>
    <div class="w3-row">
      <div class="w3-col animateUp m12">
        <div class="sectionHeader">
          <h5>Submit Event</h5>
        </div>
        <div class="whiteContainer">
          <p>Want to <strong>submit an event without creating an account</strong>? Please <strong>fill in the form below</strong> to submit your event to be posted on the website. If you are currently or want to signup to be a <strong>registered user, please use the form on the "Organizers" page</strong> in order to be paid for any advertisements purchased for your event page.</p>
        </div>
        <!-- Event Input Page -->
        <div class="whiteContainer eventInput" style="margin:0 4px;">
          <div class="w3-row">
            <div class="w3-col s12 m6" style="padding-right:4px;">
              <div class="w3-row">
                <div class="w3-col" style="width:40px;padding:8px;"><font-awesome-icon icon="pencil-alt"></font-awesome-icon></div>
                <div class="w3-rest">
                  <input type="text" class="w3-input w3-border" placeholder="Event Title" aria-label="Event Title" v-model="event.title">
                </div>
              </div>
              <div class="w3-row">
                <div class="w3-col" style="width:40px;padding:8px;"><font-awesome-icon icon="map"></font-awesome-icon></div>
                <div class="w3-rest">
                  <input type="text" class="w3-input w3-border" placeholder="Address" aria-label="Address" v-model="event.address">
                </div>
              </div>
              <div class="w3-row">
                <div class="w3-col" style="width:40px;padding:8px;"><font-awesome-icon icon="globe"></font-awesome-icon></div>
                <div class="w3-rest">
                  <input type="text" class="w3-input w3-border" placeholder="Event Website" aria-label="Event Website" v-model="event.website">
                </div>
              </div>
              <textarea class="w3-input w3-border" id="about" rows="3" v-model="event.description" placeholder="Event description"></textarea>
              <!-- TODO: tiny-mce here -->
              <!-- npm install @tinymce/tinymce-vue -->
            </div>

            <div class="w3-col s12 m6" style="padding-left:4px;">
              <div class="w3-border text-center">
                <div class="sectionHeader" style="margin:0;">
                  <h5 style="margin:0;">Event Image</h5>
                </div>
                <div class="progress" v-if="currentUploadProgress">
                  <div class="progress-bar w3-green" role="progressbar" :style="{width: (currentUploadProgress) + '%'}"></div>
                </div>
                <div class="card-body w3-center" style="background:#eee; min-height:100%;">
                  <img :alt="event.title" v-if="event.image" :src="event.image" style="width:100%; max-width:300px" />
                  <div style="clear:both"></div>
                  <p v-if="!event.image">Please add an event image using the "Choose File" button.</p>
                  <input type="file" @change="uploadImage($event.target.files)" ref="eventFileUpload" accept=".png,.jpg" style="margin:8px 0;" />
                </div>
              </div>
              <div class="errorMessageContainer " v-if="errorMessage">
                <h5 class="text-danger">{{errorMessage}}</h5>
              </div>
              <div class="successMessageContainer " v-if="successMessage">
                <h5 class="text-success">{{successMessage}}</h5>
              </div>
            </div>
          </div>
          <div style="padding:8px 8px 0; margin:0 0 8px;" class="w3-border">
            <div class="w3-row" v-for="(item, index) of event.dates" :key="index" >
              <div class="w3-col s12 m4">
                <div class="w3-row">
                  <div class="w3-col inputLabel">Date</div>
                  <div class="w3-rest">
                    <input type="date" class="w3-input w3-border" aria-label="Date" v-model="item.date">
                  </div>
                </div>
              </div>
              <div class="w3-col s12 m4">
                <div class="w3-row">
                  <div class="w3-col inputLabel">Start</div>
                  <div class="w3-rest">
                    <input type="time" class="w3-input w3-border" aria-label="Start Time" v-model="item.start">
                  </div>
                </div>
              </div>
              <div class="w3-col s12 m4">
                <div class="w3-row">
                  <div class="w3-col inputLabel">End</div>
                  <div class="w3-rest">
                    <input type="time" class="w3-input w3-border" aria-label="End Time" v-model="item.end">
                  </div>
                </div>
              </div>
            </div>
            <div class="w3-row">
              <div class="w3-col w3-right-align">
                <button class="w3-button w3-mobile w3-blue-grey" style="border-radius:5px 0 0 5px;" @click="addDate">Add Another Date</button>
                <button class="w3-button w3-mobile w3-dark-blue-grey" style="border-radius:0 5px 5px 0;" @click="removeDate">Remove Last Date</button>
              </div>
            </div>
          </div>
          <div class="w3-row">
            <div class="w3-col s12 w3-right-align">
              <button v-if="!editing" class="w3-button w3-green w3-round" @click="addEvent">Submit Event</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import gmapsInit from '../gmaps'
import events from '@/components/events.vue'

export default {
  name: "Organizers",
  computed: mapState([
    'user',
    'userEvents',
    'organizersView',
    'events',
    'currentUploadProgress'
  ]),
  components: {
    events
  },
  data() {
    return {
      successMessage: "",
      errorMessage: "",

      event: {
        title: "",
        address: "",
        latlng: null,
        dates: [
          {
            date: "",
            start: "",
            end: ""
          }
        ],
        website: "",
        description: "",
        image: null
      },
      uploading: false,
      editing: false,
      width: window.innerWidth
    }
  },
  methods: {
    addDate() {
      const newDate = {
        date: "",
        start: "",
        end: ""
      };
      this.event.dates.push(newDate);
    },
    removeDate() {
      if (this.event.dates.length > 1) {
        this.event.dates.pop();
      } else {
        return;
      }
    },
    async addEvent() {
      this.errorMessage = ''
      if (!this.event.title) {
        this.errorMessage = "Please enter an Event Title."
        return
      } else if (!this.event.address) {
        this.errorMessage = "Please enter an Event Address."
        return
      } else if (this.event.dates.length < 1) {
        this.errorMessage = "Please enter at least one date and time."
        return
      } else if (!this.event.description) {
        this.errorMessage = "Please enter an Event Description."
        return
      } else if (!this.event.image) {
        this.errorMessage = "Please enter an Event Image."
        return
      } else {
        const itemName = this.event.title
        let newUrl = this.$options.filters.slug(itemName)
        let count = 0

        for (let i = 0; i < this.events.all.length; i++) {
          if (this.events.all[i].url === newUrl) {
            count++
            continue
          }
          for (let j = 0; j < this.events.all.length; j++) {
            if (this.events.all[i].url === newUrl + "-" + j) {
              count++
              continue
            }
          }
        }
        
        if (count > 0) {
          newUrl = newUrl + '-' + Number(count)
          this.event.title = this.event.title.replace(/\-([0-9])/g, '') + '-' + (Number(count) + 1)
        }
        this.event.url = newUrl
        this.event.email = 'darren@gomobile7.com'
        if (this.user.stripeAcct && this.user.stripeAcct.id) {
          this.event.payTo = this.user.stripeAcct.id
        }
        
        // google geocode address
        if (this.event.address && !this.event.latlng) {
          const google = await gmapsInit()
          let geocoder = new google.maps.Geocoder()
          let address = encodeURI(this.event.address)
          geocoder.geocode({'address': address}, (results, status) => {
            if (status == 'OK') {
              this.event.latlng = {
                lat: results[0].geometry.location.lat(),
                lng: results[0].geometry.location.lng()
              }
            } else {
              console.log('failed geocode: ' + status)
            }
          })
        }

        let postData = {
          uid: 0,
          event: this.event
        }
        this.$store.dispatch('addEvent', postData).then(result => {
          this.$store.dispatch('sendEmail', {email: '', type: 'eventSubmit'})
        })
      }
    },
    uploadImage(files) {
      if (!this.event.title) {
        alert('Please enter a title before uploading an image')
        this.$refs.eventFileUpload.value = null
        return
      }
      const data = {
        uid: this.user.uid,
        title: this.event.title,
        files: files
      }
      this.$store.dispatch('uploadEventImage', data).then((result) => {
        if (result.message === 'success') {
          this.$set(this.event, 'image', result.imageURL)
        } else {
          console.log(result)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
